import {
  SET_GYM_FEATURES_DATA,
  SET_GYM_FEATURES_OBJECT,
} from "../../actions/types/types";

const initState = {
  features: [
    {
      featureName: "membershipCardScanner",
      featureValue: "DISABLED",
    },
    {
      featureName: "mandateMemberImage",
      featureValue: "DISABLED",
    },
    {
      featureName: "memberAdditionalInfo",
      featureValue: "DISABLED",
    },
    {
      featureName: "joiningFees",
      featureValue: "DISABLED",
    },
    {
      featureName: "voidReasons",
      featureValue: "DISABLED",
    },
    {
      featureName: "addReasonForComplimantry",
      featureValue: "DISABLED",
    },
    {
      featureName: "extendDuration",
      featureValue: "DISABLED",
    },
    {
      featureName: "staffSessionsCashHandling",
      featureValue: "DISABLED",
    },
    {
      featureName: "prepaidBooking",
      featureValue: "DISABLED",
    },
    {
      featureName: "allowUpdateRemainingSessions",
      featureValue: "DISABLED",
    },

    {
      featureName: "payroll",
      featureValue: "DISABLED",
    },
    {
      featureName: "sharedSubscriptions",
      featureValue: "DISABLED",
    },
    {
      featureName: "multiplePackages",
      featureValue: "DISABLED",
    },
  ],
  gymFeaturesObject: {
    membershipCardScanner: false,
    mandateMemberImage: false,
    memberAdditionalInfo: false,
    joiningFees: false,
    voidReasons: false,
    addReasonForComplimantry: false,
    multiplePackages: false,
    extendDuration: false,
    staffSessionsCashHandling: false,
    payroll: false,
    sharedSubscriptions: false,
    allowUpdateRemainingSessions:false
  },
  loading: false,
};

const GymFeaturesReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_GYM_FEATURES_DATA:
      return {
        ...state,
        features: action.payload.data,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload.data,
      };
    case SET_GYM_FEATURES_OBJECT:
      return {
        ...state,
        gymFeaturesObject: action.payload.data,
      };

    default:
      return { ...state };
  }
};

export default GymFeaturesReducer;
